import { GuardResult, UrlTree } from '@angular/router';
import { CurrentUser } from 'app/shared/model';

export const canUseFeature = (flag: boolean, user: CurrentUser, redirectLocation: UrlTree, allowedUserTypes: string[] = ['system']): GuardResult => {
    try {
        const verifiedUserType = user ? allowedUserTypes.includes(user.owner.type.toLowerCase()) : false;
        
        const canNavigate = flag || verifiedUserType;
        if (canNavigate) {
            return canNavigate;
        }
        return redirectLocation;
    } catch (error) {
        // In an ideal world this method would never fail... but if we do, then we need to at least redirect the user somewhere valid.
        console.error(error);
        return redirectLocation;
    }
}
